/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2022 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */

export default class GameActions
{
    public static readonly ACTION_SPIN: string = 'everi.action.spin';
    public static readonly ACTION_PICK: string = 'everi.action.pick';
    public static readonly ACTION_PRIZE: string = 'everi.action.prize';
    public static readonly ACTION_REEL_TIMINGS_GET: string = 'everi.action.reel_timings.get';
    public static readonly ACTION_REEL_TIMINGS_SET: string = 'everi.action.reel_timings.set';
}
